import { DeviceGenre } from '@/constants/device';
import type { DeviceGroupListItem } from './-types';
export const DEVICE_GROUP_COLUMNS = {
  NAME: 'name',
  INTENDED_USE: 'intendedUse',
  TARGET_DEVICE_COUNT: 'targetDeviceCount',
  GENRE_WORKSTATION: `genre_${DeviceGenre.WORKSTATION}`,
  GENRE_LAPTOP: `genre_${DeviceGenre.LAPTOP}`,
  GENRE_MOBILE: `genre_${DeviceGenre.MOBILE}`,
  GENRE_TABLET: `genre_${DeviceGenre.TABLET}`,
  GENRE_MONITOR: `genre_${DeviceGenre.MONITOR}`,
  GENRE_PRINTER: `genre_${DeviceGenre.PRINTER}`,
  GENRE_SERVER: `genre_${DeviceGenre.SERVER}`,
  GENRE_OTHER: `genre_${DeviceGenre.OTHER}`,
  ACTIONS: 'actions'
} as const;
export const SortColumns = ['name'] as const satisfies Array<keyof DeviceGroupListItem>;
export const GENRE_COLUMN_BY_GENRE = {
  [DeviceGenre.WORKSTATION]: DEVICE_GROUP_COLUMNS.GENRE_WORKSTATION,
  [DeviceGenre.LAPTOP]: DEVICE_GROUP_COLUMNS.GENRE_LAPTOP,
  [DeviceGenre.MOBILE]: DEVICE_GROUP_COLUMNS.GENRE_MOBILE,
  [DeviceGenre.TABLET]: DEVICE_GROUP_COLUMNS.GENRE_TABLET,
  [DeviceGenre.MONITOR]: DEVICE_GROUP_COLUMNS.GENRE_MONITOR,
  [DeviceGenre.PRINTER]: DEVICE_GROUP_COLUMNS.GENRE_PRINTER,
  [DeviceGenre.SERVER]: DEVICE_GROUP_COLUMNS.GENRE_SERVER,
  [DeviceGenre.OTHER]: DEVICE_GROUP_COLUMNS.GENRE_OTHER
} as const satisfies Record<DeviceGenre, string>;